import { useState } from 'react';

const faqs = [
  {
    q: '漫蛙漫画网是免费的吗？',
    a: '漫蛙漫画网提供的漫画追更与漫画最新更新追踪服务完全免费。我们通过聚合全网连载漫画更新信息，帮助漫友高效管理追更列表、获取更新提醒，不收取任何费用。',
  },
  {
    q: '如何添加漫画到我的追更列表？',
    a: '你可以在追更助手中使用搜索功能找到你想追的连载漫画，点击「加入追更」即可添加到个人追更列表。系统会自动追踪该漫画的更新状态，有新章节发布时第一时间通知你。',
  },
  {
    q: '追更提醒是实时推送的吗？',
    a: '我们的漫画更新提醒系统会在检测到连载漫画发布新章节后，最快在数分钟内推送通知。更新速度取决于漫画来源平台的发布速度，漫蛙确保在第一时间完成同步。',
  },
  {
    q: '支持哪些漫画类型的追更？',
    a: '漫蛙漫画网支持全题材漫画追更，包括但不限于：热血战斗、悬疑推理、恋爱日常、异世界穿越、科幻奇幻、都市职场、体育竞技、恐怖惊悚等。国漫、日漫、韩漫均有覆盖。',
  },
  {
    q: '漫画更新信息来源可靠吗？',
    a: '我们的追更引擎对接多个权威漫画更新信息源，通过交叉验证确保漫画最新更新的准确性。所有更新信息均来自公开的正版漫画平台和官方发布渠道。',
  },
  {
    q: '移动端和网页版数据同步吗？',
    a: '追更助手支持跨设备数据同步。你在网页版添加的追更列表、阅读进度和提醒设置会自动同步到移动端，无论使用哪个设备都能无缝衔接追更体验。',
  },
];

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
            追更问答
          </h2>
          <p className="text-foreground-600 text-base md:text-lg">
            关于漫画追更的常见问题，帮你快速了解漫蛙漫画网
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="rounded-xl bg-background-50 border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between gap-4 p-5 text-left cursor-pointer hover:bg-primary-50/30 transition-colors"
              >
                <h3 className="text-base font-semibold text-foreground-900 pr-4">{faq.q}</h3>
                <div className={`w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 transition-all duration-200 ${
                  openIndex === i ? 'bg-primary-500 text-white rotate-45' : 'bg-background-100 text-foreground-500'
                }`}>
                  <i className="ri-add-line text-lg"></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-5 pb-5">
                  <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}